import React, { useState } from 'react';
import Button from './PrivacyButton';

const Footer = () => {

  const [click, setClick] = useState(false);

  return (
    <div className="bg-[#F8F8F8] px-32 py-5 lg:text-[18px] md:text-[15px] sm:text-[8px] lg:h-[4rem] md:h-[4rem] sm:h-[3.5rem] ">
      <div className="xl:max-w-[1440px] xl:mx-auto flex justify-between md:flex-none sm:flex-none">
        <div className="flex ">
          <div className="">تواصــل معنــا</div>
          <div className="flex">
            <a href="https://t.me/TG_Academyy" target="_blank" rel="noreferrer">
              <img src="assets/images/telegram.svg" className='cursor-pointer lg:h-[25px] md:h-[25px] sm:h-[15px] lg:mr-4 sm:mr-1'/>
            </a>
            <a href="https://www.linkedin.com/company/thegame-academy/" target="_blank" rel="noreferrer">
              <img src="assets/images/Group1061.svg" className='cursor-pointer lg:h-[25px] md:h-[25px] sm:h-[15px] lg:mr-4 sm:mr-1'/>
            </a>
            <a href="https://www.facebook.com/tg.academy0/" target="_blank" rel="noreferrer">
              <img src="assets/images/facebook.svg" className='cursor-pointer lg:h-[25px] md:h-[25px] sm:h-[15px] lg:mr-4 sm:mr-1'/>
            </a>
          </div>
        </div>
        <div dir="ltr" className="flex md:flex-none sm:flex-none">
          <div className=""><span>&copy;</span> 2022 TG Developers</div>

          <Button text="سياسة الخصوصية" click={click} onClick={() => setClick(!click)}/>
        </div>
      </div>
    </div> 
  )
}

export default Footer;